.container {
  width: 100%;
  padding-right: 30px;
  margin-bottom: 25px;
}

.search {
  margin-bottom: 20px;
}
